import React from 'react';
import { createWidget } from '../utils';

export const TotalCost = createWidget({
  key: 'total_cost_demo',
  label: 'Total Cost (Demo)',
  description: (
    <>
      <p>Display total revenue information.</p>
      <p>
        <small>
          <em>This is a demo widget with no functionality.</em>
        </small>
      </p>
    </>
  ),
  icon: <i className="sv sv-chart-growth" />,
  component: ({ options }) => {
    return (
      <div className="w-100 h-100 text-center p-2">
        <img src="/public/assets/images/TotalCostBarChart.png" />
      </div>
    );
  },
  options: {
    settings: { minW: 4, minH: 6 },
  },
});
